import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { AuthorizedAppsViewProvider } from 'pages/settings/pages/developer/pages/authorizedApps/context/authorizedAppsViewContext'

const AuthorizedAppsPageLayoutContent = () => {
  return <Outlet />
}

export const AuthorizedAppsPageLayout = observer(() => {
  return (
    <AuthorizedAppsViewProvider>
      <AuthorizedAppsPageLayoutContent />
    </AuthorizedAppsViewProvider>
  )
})
